module.exports = __webpack_public_path__ + "static/media/buildingConstruction44.373bfc0b.jpg";